import { fetchScripts } from "./api";

export const initializeExternalFormScripts = async (formsUrl : string) => {
  const scripts = await fetchScripts(formsUrl);
  
  // Loop through the scripts. Render the first group (core utils) first, then the second group of extra scripts.
  await Promise.all(scripts.loadFirst.map(async script => {
    return registerScript(script);
  })).catch(function(err) {
    console.log(err.message);
  });

  await Promise.all(scripts.loadSecond.map(async script => {
    return registerScript(script);
  })).catch(function(err) {
    console.log(err.message);
  });
}

export const registerScript = async (url : string) => {
  return new Promise((resolve, reject) => {
    try {
      const loaded = isScriptLoaded(url);
      if(loaded) {
        console.log(`The ${url} script is already loaded on the page.`);
        return resolve({ status: true });;
      }
      const filename = url.substring(url.lastIndexOf('/')+1);
      
      // Append the script element to the head section
      const script = document.createElement('script');
      script.src = url;
      script.id = filename;
      script.async = false;
      
      script.addEventListener("load", (ev) => {
        resolve({ status: true });
      });
      
      script.addEventListener("error", (ev) => {
        reject({
          status: false,
          message: `Failed to load the script ＄{FILE_URL}`
        });
      });
      document.head.appendChild(script);
    } catch (error) {
        reject(error);
    }
});
}

const isScriptLoaded = (url) => {
  const scripts = document.querySelectorAll(`script[src="${url}"]`);
  return scripts.length > 0;
}